import { type FC } from 'react';
import { MessageSimple, useChatContext, useMessageContext, type MessageUIComponentProps } from 'stream-chat-react';
import { pickMessageRenderer } from '../pick-message-renderer';

/**
 * Message UI wrapper that renders a message's text with the renderer that suits
 * its author. See {@link pickMessageRenderer} for why that depends on who wrote
 * it (IP-2192).
 */
export const CustomMessage: FC<MessageUIComponentProps> = (props) => {
  const { message } = useMessageContext('CustomMessage');
  const { client } = useChatContext('CustomMessage');

  return <MessageSimple {...props} renderText={pickMessageRenderer(message.user ?? undefined, client.userID)} />;
};
